/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { infoDisplayStyles, InfoDisplayStyles } from "@eisinc/App/SharedStyles/InfoDisplayStyles";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    title?: string;
    value?: any;
    forwardAs?: string;
    extendedProps?: { [key: string]: string };
}

export interface OrderDetailsInfoDisplayProps {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    contentText?: TypographyPresentationProps;
}

const styles: OrderDetailsInfoDisplayProps = {
    wrapper: {
        css: css`
            white-space: pre-wrap;
        `,
    },
    titleText: {
        size: 12,
        color: "common.ui7",
        css: css`
            display: block;
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
    contentText: {
        size: 14,
        weight: 500,
        css: css`
            white-space: pre-wrap;
            word-wrap: break-word;
        `,
    },
};

type Props = OwnProps;

const OrderDetailsInfoDisplay: FC<Props> = ({ title, value, extendedProps, forwardAs }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            {title && <Typography {...styles.titleText}>{translate(title)}:</Typography>}
            {forwardAs === "component" ? (
                value
            ) : (
                <Typography {...styles.contentText} color={extendedProps?.contentColor}>
                    {value}
                </Typography>
            )}
        </StyledWrapper>
    );
};

export default OrderDetailsInfoDisplay;
